import { cn as d } from "../../../lib/utils.es.js";
import { Spinner as p } from "../spinner/Spinner.es.js";
import { buttonVariants as f } from "./Button.variants.es.js";
import { jsx as n, jsxs as b } from "react/jsx-runtime";
import { Slot as l, Slottable as v } from "@radix-ui/react-slot";
var y = ({ className: m, variant: r, size: o, asChild: a = !1, iconOnly: e, loading: t = !1, disabled: i, children: s, ...u }) => /* @__PURE__ */ b(a ? l : "button", {
  "aria-busy": t || void 0,
  className: d(f({
    iconOnly: e,
    variant: r,
    size: o,
    className: m
  })),
  "data-icon-only": e ? "true" : void 0,
  "data-loading": t ? "true" : void 0,
  "data-size": o,
  "data-slot": "button",
  "data-variant": r,
  disabled: a ? i : i || t,
  ...u,
  children: [t && /* @__PURE__ */ n(p, {
    "aria-hidden": !0,
    "data-slot": "button-spinner"
  }), /* @__PURE__ */ n(v, { children: s })]
});
export {
  y as Button
};
